import EntityServise from "./entityService";

class ActionService extends EntityServise {

    constructor() {
        super("action");
    }


    async getByEntity(entity) {
        return await this.http.get(`${this.routeApi}/entity-${entity}`);
    }

    async getSeparate() {
        return await this.http.get(`${this.routeApi}/separate`);
    }
}

export default new ActionService();